import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core"
import classnames from "clsx"
import ButtonRounded from "components/Common/ButtonRounded"
import AppContext from "contexts/App"
import { useEffect, useState } from "react"
import { useContext } from "react"
import { useQueryClient } from "react-query"

import Step1 from "./components/Step1"
import Step2 from "./components/Step2"
import useStyles from "./styles"

// This Dialog opens from the APplicants sidebar tab, when clicking View Details next to an applicant.
// Step 1 is a list of all applicant's applications for the current entity
// Step 2 is the selected application & all associated info
const ApplicantDetails = () => {
  const classes = useStyles()

  const { dialogs, closeDialog, openSnackBar } = useContext(AppContext)
  const thisDialog = dialogs?.["applicantDetails"] || {}
  const { open = false, data = {} } = thisDialog
  let user = thisDialog?.data?.selected
  let getDataMutation = thisDialog?.data?.getDataMutation
  let openMutation = thisDialog?.data?.openMutation
  const [loading, setLoading] = useState(false)

  const [applicantData, setApplicantData] = useState(null)
  const [step, setStep] = useState(0)
  const [currentApplication, setCurrentApplication] = useState({})
  //state to hide the more areas data in step2
  const [hide, setHide] = useState(false)
  const [changeStatus, setChangeStatus] = useState(false)
  //to only the get applicants by entity once
  const [onlyOnce, setOnlyOnce] = useState(true)

  const handleClose = () => {
    closeDialog("applicantDetails")
    setTimeout(() => {
      setApplicantData([])
      setStep(0)
      setCurrentApplication({})
      setOnlyOnce(true)
      setChangeStatus(false)
    }, 200)
  }

  useEffect(() => {
    //do this call if we chane status in the next step or we just open the dialog
    if ((step === 0 && changeStatus) || (onlyOnce && open)) {
      setLoading(true)
      getDataMutation
        .mutateAsync(user?.user_id)
        .then((res) => {
          setApplicantData(res)
          setLoading(false)
        })
        .catch(() => {
          setLoading(false)
          openSnackBar({ message: "Error opening user applications" })
        })
      if (changeStatus) {
        setChangeStatus(false)
      }
      setOnlyOnce(false)
    }
  }, [step, changeStatus, open])

  const handleBack = () => {
    if (hide && step === 1) {
      setHide(false)
    } else {
      setStep((oldState) => oldState - 1)
    }
  }

  const steps = [
    <Step1
      key={1}
      mutation={getDataMutation}
      applicantData={applicantData}
      setStep={setStep}
      setCurrentApplication={setCurrentApplication}
      loading={loading}
      user={user}
    />,
    <Step2
      key={2}
      step={step}
      currentApplication={currentApplication}
      openMutation={openMutation}
      setHide={setHide}
      hide={hide}
      closeFunction={handleClose}
      getDataMutation={getDataMutation}
      setLoading={setLoading}
      setApplicantData={setApplicantData}
      setChangeStatus={setChangeStatus}
    />,
  ]
  return (
    <Dialog open={open} classes={{ paperWidthSm: classes.papper }}>
      <DialogTitle disableTypography>
        <Typography variant="h2">
          {step === 0
            ? user?.first_name + "'s Applications"
            : currentApplication?.name}
        </Typography>
      </DialogTitle>
      <DialogContent className={classes.content}>{steps[step]}</DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%">
          {step === 1 && (
            <ButtonRounded
              color="primary"
              variant="contained"
              onClick={handleBack}
              type="button"
              className={classes.backButton}
            >
              Back
            </ButtonRounded>
          )}
          <ButtonRounded
            color="primary"
            variant="outlined"
            onClick={handleClose}
            type="button"
          >
            Close
          </ButtonRounded>
        </Box>
      </DialogActions>
    </Dialog>
  )
}

export default ApplicantDetails
